import React, { useEffect, useState } from "react";
import { dbReview } from "./firebaseReview";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { Star } from "lucide-react";
import "../starss.css"; // import CSS

// ⭐ Star display
const StarDisplay = ({ value }) => {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((i) => {
        const full = value >= i;
        const half = !full && value >= i - 0.5;

        if (full) {
          return <Star key={i} className="star full" style={{ fill: "#facc15" }} />;
        }

        if (half) {
          return (
            <div key={i} className="star-half-wrapper">
              <Star className="star empty" />
              <Star className="star half" style={{ clipPath: "inset(0 50% 0 0)", fill: "#facc15" }} />
            </div>
          );
        }

        return <Star key={i} className="star empty" />;
      })}
    </div>
  );
};

const CustomerReviewsDisplay = () => {
  const [reviews, setReviews] = useState([]);
  const [averageAll, setAverageAll] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      const q = query(collection(dbReview, "reviews"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);

      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setReviews(list);

      if (list.length > 0) {
        const total = list.reduce((sum, r) => sum + Number(r.averageRating), 0);
        setAverageAll((total / list.length).toFixed(1));
      }
    };

    fetchReviews();
  }, []);


return (
  <>
    {reviews.length > 0 && (
      <a href="/stars" style={{ textDecoration: "none", color: "grey" }}>
        <div className="re">
          <div className="ove">
            <h6>Customer Reviews</h6>
            <div className="oves">
              <StarDisplay value={Number(averageAll)} />
              <span className="avg">{averageAll}</span>
              {/* <span className="count">({reviews.length} reviews)</span> */}
            </div>
          </div>
        </div>
      </a>
    )}
  </>
);
};

export default CustomerReviewsDisplay;
